import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronArrowDown } from '../../../assets/icons';

interface DropdownButtonProps {
    options: { name: string, value: string }[];
    mainButtonLabel: string;
    mainButtonlClick: () => void;
    optionClick: (name: string) => void;
    className?: string;
}

const DropdownButton: React.FC<DropdownButtonProps> = ({
    options,
    mainButtonLabel,
    mainButtonlClick,
    optionClick,
    className,
}) => {
    return (
        <div className="inline-flex rounded-md shadow-xs text-neutral-25  bg-darkcolor-700">
            <button
                type="button"
                onClick={() => mainButtonlClick()}
                className={`border-solid border-darkcolor-400 border-[1px] relative inline-flex items-center rounded-l-md px-8 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:z-10 ${className ? className : ''}`}
            >
                {mainButtonLabel}
            </button>
            <Menu as="div" className="relative -ml-px block">
                <MenuButton className="h-full border-solid border-darkcolor-400 border-[1px] relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 hover:bg-gray-50 focus:z-10">
                    <span className="sr-only">Open options</span>
                    <ChevronArrowDown />
                </MenuButton>
                <MenuItems
                    transition
                    className=" text-neutral-25  bg-darkcolor-700 border-solid border-darkcolor-400 border-[1px] absolute right-0 z-10 mt-2 -mr-1 w-56 origin-top-right rounded-md  shadow-lg transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                >
                    <div className="py-1">
                        {options.map((item) => (
                            <MenuItem key={item.name}>
                                <a
                                    href="#"
                                    role="button"
                                    onClick={() => optionClick(item.value)}
                                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
                                >
                                    {item.name}
                                </a>
                            </MenuItem>
                        ))}
                    </div>
                </MenuItems>
            </Menu>
        </div>
    )
}

export default DropdownButton;